import FeesCard from "./FeesCard";

export default function Class6() {
  return (
    <FeesCard
        badge="Class 6"
        title="💰 Class 6 Tuition Details"
        className="6th Standard"
        fee="₹1,200"
        days="Monday – Saturday"
        time="4:30 PM – 7:30 PM"
        subjects={[
          "English",
          "Mathematics",
          "Science",
          "Social Science"
        ]}
        approach={[
          "Concept clarity",
          "Problem-solving focus",
          "Weekly tests"
        ]}
        note="₹500 extra for evening snacks / milk.
        Self pickup & drop only."
      />
  );
}